import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import AttributesHome from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'contact_fields_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'attributes_list',
          redirect: to => {
            return { name: 'contact_fields_list', params: to.params };
          },
        },
        {
          path: 'contact-fields/list',
          name: 'contact_fields_list',
          component: AttributesHome,
          props: {
            attributeModel: 'contact_attribute',
          },
          meta: {
            featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
        {
          path: 'conversation-fields/list',
          name: 'conversation_fields_list',
          component: AttributesHome,
          props: {
            attributeModel: 'conversation_attribute',
          },
          meta: {
            featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
      ],
    },
  ],
};
